import React, { useState, useEffect } from "react";
import { Box, DialogContent, Divider, Grid, Tooltip } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import { TextIconButtonComponent } from "../../../atom";
import { useNavigate } from "react-router-dom";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Actions } from "../../../../core/modules/Actions";
import { connect } from "react-redux";
import getSymbolFromCurrency from "currency-symbol-map";
import { IMAGE_URL } from "../../../../core/Constant";
import moment from "moment";

const AdminCourseFormView = ({
  courseID,
  getCourseMainDetails,
  mainDetailsState,
}) => {
  const [scroll, setScroll] = useState("paper");
  const [name, setName] = useState("");
  const [duration, setDuration] = useState("");
  const [priority, setPriority] = useState("");
  const [price, setPrice] = useState([]);
  const [lecturer, setLecturer] = useState("");
  const [description, setDescription] = useState("");
  const [course_image, setCourseImage] = useState("");
  const [totalEnrolled, setTotalEnrolled] = useState(0);
  const [isFree, setIsFree] = useState(0)
  const [isMultiBatch, setMultiBatch] = useState(0)

  const navigate = useNavigate();
  useEffect(() => {
    if(courseID && courseID !== 0){
     getCourseMainDetails({
        id: courseID,
      });
    } 
  }, [courseID]);

  useEffect(() => {
    setName(mainDetailsState.name);
    setDescription(mainDetailsState.description);
    setDuration(mainDetailsState.duration);
    setPriority(mainDetailsState.priority)
    setLecturer(mainDetailsState.lecturer);
    // setPrice(
    //   getSymbolFromCurrency(mainDetailsState.currency) +
    //     mainDetailsState?.course_currencies
    // );
    setPrice(mainDetailsState?.course_currencies);
    setCourseImage(mainDetailsState.course_image);
    setTotalEnrolled(mainDetailsState.total_enrolled);
    setIsFree(mainDetailsState?.is_free)
    setMultiBatch(mainDetailsState?.is_multi_batch)
  }, [mainDetailsState]);

  return (
    <>
      <form>
        <DialogContent>
          <Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
              <TextIconButtonComponent
                icon={faStar}
                btnText={"View Reviews"}
                onclick={() =>
                  navigate("/admin-review", {
                    state: {
                      course_id: courseID,
                    },
                  })
                }
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
              <img
                src={IMAGE_URL + course_image}
                style={{
                  objectFit: "contain",
                  width: "350px",
                  height: "250px",
                }}
                alt="course-image"
              />
            </Box>

            <Box>
              <TextInputComponent
                label={"Name"}
                placeholder="abc"
                value={name}
              />
            </Box>
            
            {
               isFree === 0 && <Box>
              <p
                style={{
                  padding: 12,
                  margin: 0,
                  marginBottom: 10,
                  color: "#4E657C",
                  fontSize: 19,
                  fontWeight: 700,
                }}
              >
                Plans
              </p>
              <Grid container p={2} gap={2} justifyContent={"center"}>
                <Grid item xs={12}>
                  <Grid container>
                    {
                      isMultiBatch === 1 && <Grid
                      item
                      xs={2}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 700,
                          fontFamily: "Montserrat",
                        }}
                      >
                        Plan Type
                      </span>
                     </Grid>
                    }
                    <Grid
                      item
                      xs={2}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 700,
                          fontFamily: "Montserrat",
                        }}
                      >
                        Duration
                      </span>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 700,
                          fontFamily: "Montserrat",
                        }}
                      >
                        Expiry Date
                      </span>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 700,
                          fontFamily: "Montserrat",
                        }}
                      >
                        Batch
                      </span>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 700,
                          fontFamily: "Montserrat",
                        }}
                      >
                        Price
                      </span>
                    </Grid>
                  </Grid>
                </Grid>

                {price?.map((item, index) => {
                  const planName = item?.plan_name || "";
                  const needsTooltip = planName.length > 50
                  const displayedText = needsTooltip
                     ? `${planName?.substring(0, 50)}...`
                     : planName;
                  
                  return (
                    <Grid
                      item
                      xs={12}
                      key={index + 1}
                      sx={{ backgroundColor: "#f2f6f8" }}
                    >
                      <Grid container>
                        {
                          isMultiBatch === 1 && <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <span> 
                            {needsTooltip ? (
                              <Tooltip title={planName} placement="top" arrow>
                                <span style={{ cursor: "pointer" }}>
                                  {displayedText}
                                </span>
                              </Tooltip>
                            ) : (
                              displayedText
                            )} 
                          </span>
                         </Grid>
                        }
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <span>{item?.duration_weeks}</span>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <span>{item?.expires_at ? moment(item?.expires_at).format("DD-MM-YYYY") : ""}</span>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <span>{item?.batch_year && item?.batch_month ? moment({
                                  year: item?.batch_year,
                                  month: item?.batch_month - 1,
                                }).format("MMMM YYYY")  : ""}</span>
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <span>{item?.price}</span>
                        </Grid>
                      </Grid>
                      {/* <Divider variant="middle" /> */}
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            }
            
            {
              isFree === 1 && <Box>
              <TextInputComponent
                label={"Duration (Weeks)"}
                placeholder="3"
                value={duration}
              />
             </Box>
            }
            
            <Box>
              <TextInputComponent
                label={"Priority"}
                placeholder=""
                value={priority}
              />
            </Box>

            <Box>
              <TextInputComponent
                label={"Total Enrolled"}
                placeholder="456"
                value={totalEnrolled}
              />
            </Box>

            <Box>
              <TextInputComponent
                label={"Lecturer"}
                placeholder="Tom Hardy"
                value={lecturer}
              />
            </Box>

            <Box m={1}>
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  marginBottom: 10,
                  color: "#4E657C",
                  fontSize: 19,
                  fontWeight: 700,
                }}
              >
                Description
              </p>

              <Box p={1} sx={{ backgroundColor: "#F2F6F8", borderRadius: 2 }}>
                <span
                  style={{
                    fontFamily: "Montserrat",
                    // fontWeight: 500,
                    color: "#b0b3b6",
                    wordBreak:"break-word"
                  }}
                >
                  {description}
                </span>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </form>
    </>
  );
};

export default connect(
  (state) => ({
    mainDetailsState: state.course.get("mainDetailsState"),
  }),
  {
    getCourseMainDetails: Actions.course.getCourseMainDetails,
  }
)(AdminCourseFormView);
